// All the constants for participants container should be placed here

import { AllAdmins } from 'lib/authorization/Roles'

export const VALID_EMAIL_REGEX =
  /^[a-zA-Z0-9.%&'+_-]+@[a-zA-Z0-9._-]+\.[a-zA-Z]{2,}$/gim
export const FILTER_VALUES = ['none', 'active', 'blocked', 'pending_activation']
export const UNPROCESSABLE_ENTITY = 422
export const DATE_PICKER_MENU_OPTIONS = [
  'All time',
  'Last 7 days',
  'Last 30 days',
  'custom',
]
export const DEBOUNCE_SEARCH_TIME_LIMIT = 500
export const OPTIONS_CHAR_LIMIT = 29
export const IMPORT_FILTER_VALUES = ['none', 'imported']
export const ENGAGEMENT_LEVEL_VALUES: Array<Condition> = [
  'is_aware',
  'is_informed',
  'is_engaged',
]

export const FB_FILTER_LIST = [
  {
    name: 'hub',
    icon: 'device_hub_icon',
    defaultOpen: true,
    condition: 'is_engaged',
    component: 'FilterByHub',
    fieldName: 'hub',
    value: '',
    allowedTo: [AllAdmins],
    isSingle: true,
    iconStyle: 'outlined',
  },
  {
    name: 'projectTag',
    tooltip: '',
    icon: 'local_offer',
    component: 'ProjectTag',
    defaultOpen: true,
    condition: 'has_tags',
    fieldName: 'project_tag',
    value: '',
    allowedTo: [AllAdmins],
    isSingle: true,
    iconStyle: 'outlined',
  },
  {
    name: 'projects',
    tooltip: '',
    divider: true,
    icon: 'work_outlined',
    component: 'FilterByProject',
    defaultOpen: true,
    condition: 'is_aware',
    fieldName: 'project_activity',
    value: '',
    allowedTo: [AllAdmins],
    isSingle: false,
    iconStyle: 'outlined',
  },
  {
    name: 'email',
    icon: 'email_outlined',
    component: 'Email',
    defaultOpen: true,
    condition: 'contains',
    fieldName: 'email',
    value: '',
    allowedTo: [AllAdmins],
    iconStyle: 'outlined',
  },
  {
    name: 'participantTag',
    tooltip: '',
    icon: 'label',
    component: 'ParticipantTag',
    defaultOpen: true,
    condition: 'has_tags',
    fieldName: 'participant_tag',
    value: '',
    allowedTo: [AllAdmins],
    isSingle: true,
    iconStyle: 'outlined',
  },
  {
    name: 'screenName',
    icon: 'person_outlined',
    component: 'ScreenName',
    defaultOpen: true,
    condition: 'contains',
    fieldName: 'login',
    value: '',
    allowedTo: [AllAdmins],
    iconStyle: 'outlined',
  },
  {
    name: 'signUpQuestion',
    tooltip: '',
    icon: 'question_answer',
    component: null,
    condition: 'matches set of',
    fieldName: 'signup_form',
    questionId: '',
    optionIds: [],
    allowedTo: [AllAdmins],
    iconStyle: 'outlined',
  },
  {
    name: 'participantStatus',
    tooltip: '',
    icon: 'how_to_reg',
    component: 'StatusFilter',
    defaultOpen: true,
    condition: 'is',
    fieldName: 'status',
    value: '',
    allowedTo: [AllAdmins],
    isSingle: true,
    iconStyle: 'outlined',
  },

  {
    name: 'suburbs',
    tooltip: '',
    icon: 'map',
    component: 'FilterBySuburbs',
    defaultOpen: false,
    condition: 'matches set of',
    fieldName: 'suburb',
    value: '',
    allowedTo: [AllAdmins],
    isSingle: true,
    divider: true,
    iconStyle: 'outlined',
  },
  {
    name: 'location',
    tooltip: '',
    icon: 'location_on_outlined',
    component: 'Location',
    defaultOpen: true,
    condition: 'matches set of',
    fieldName: 'location',
    value: '',
    allowedTo: [AllAdmins],
    isSingle: true,
    divider: true,
    iconStyle: 'outlined',
  },
  {
    name: 'participantImport',
    tooltip: '',
    icon: 'move_to_inbox',
    component: 'ImportFilter',
    defaultOpen: true,
    condition: 'is',
    fieldName: 'status',
    value: '',
    allowedTo: [AllAdmins],
    isSingle: true,
    iconStyle: 'outlined',
  },
  {
    name: 'joinDate',
    tooltip: '',
    icon: 'calendar_today',
    component: 'FilterByJoinDate',
    defaultOpen: true,
    startDate: '',
    endDate: '',
    selection: 'key',
    isDateRangeVisible: false,
    condition: 'before',
    fieldName: 'joined',
    value: '',
    allowedTo: [AllAdmins],
    isSingle: true,
    iconStyle: 'outlined',
  },
  {
    name: 'lastSeen',
    icon: 'perm_contact_calendar',
    component: 'FilterByLastSeen',
    defaultOpen: true,
    condition: 'before',
    fieldName: 'last_visited',
    value: '',
    startDate: '',
    endDate: '',
    selection: 'key',
    isDateRangeVisible: false,
    allowedTo: [AllAdmins],
    isSingle: true,
    iconStyle: 'outlined',
  },
]

export const participantProfileTabs = ['profile', 'activity', 'notes']

export const OLD_PRM_URL = `/admin/people/participants`
export const NEW_PRM_URL = `/adm/participants`

export const PARTICIPANT_ROUTES = [
  {
    path: '/adm/participant/:id',
  },
  {
    path: '/adm/participants',
  },
]

export const SIGN_UP_DATE_QUESTION = 'DateQuestion'
export const YEAR_FORMAT = 'YYYY'
export const DEFAULT_DATE_FORMAT = 'MM/DD/YYYY'
export const API_DATE_FORMAT = 'DD.MM.YYYY'
